import React, { useEffect, useState } from 'react'

import {LeftArrowWhite, SearchIcon, SearchIconWhite} from '../../../../assets/images'

import { Tab, Tabs } from 'react-bootstrap';

import { getSiteAddressById, getZoneListAPI } from '../../../../services/configurationServices';

import ZoneDetailsForm from './ZoneDetailsForm';
import ZoneMap from './ZoneMap';
import TabEmergencyContact from '../Common/TabEmergencyContact';

const AddZoneForm = ({isDarkTheme, setZoneForm, zoneForm, site, country, countryState, resetSite }) => {
    
    const [searchZoneName, setSearchZoneName] = useState("");
    const [zoneList, setZoneList] = useState(null)
    const [masterZoneList, setMasterZoneList] = useState(null)
    const [selectedZone, setSelectedZone] = useState(null);
    const [isFormEdit, setIsFormEdit] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('Zone_Details');

    useEffect(() => {
        if(site?.SiteID != 0){
            getZoneList(site?.SiteID);
        }
    }, [site])

    const handleSite = () =>{
        setZoneForm(false)
        resetSite();
    }

    const onSearchChange = (val) => {
        setSearchZoneName(val);
        let temp = masterZoneList.filter((item) => item.SiteName.toLowerCase().includes(val.toLowerCase()))
        setZoneList(temp);
    }

    const getZoneList = (id) => {
        getZoneListAPI(id).then((resp) => {
            if (resp.Status == "success" && resp.Data != null) {
                setZoneList(resp.Data);
                setMasterZoneList(resp.Data);
              } else {
                setZoneList(null);
                setMasterZoneList(null)
              }
        }).catch(err => console.log(err)) 
    }

    const getSiteAddressDetails = (id, siteData) => {
        getSiteAddressById(id)
            .then((res) => {
                if(res.Status == "success"){
                    let zoneObj = {
                        AddressId: res.Data[0].AddressId,
                        SiteID: siteData.SiteID,
                        SiteName: siteData.SiteName,
                        BranchID: siteData.BranchID,
                        Address: res.Data[0].Address,
                        clientID: siteData.ClientId,
                        AddCustomerName: "",
                        CountryId: res.Data[0].Countryid,
                        StateId: res.Data[0].Stateid,
                        City: res.Data[0].City,
                        Region: res.Data[0].Region,
                        pincode: res.Data[0].PinCode,
                        Area: res.Data[0].Area,
                        SiteModeID: siteData.SiteModeID,
                        ParentId: siteData.ParentID,
                        Lattitude: siteData?.Lattitude,
                        Longitude: siteData?.Longitude,
                        isMap: siteData?.IsBingMap,
                        mapUrl: siteData?.PinUrl            
                      };
                    setSelectedZone(zoneObj)
                }else{
                    setSelectedZone(siteData)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <>
            <div className="SiteMainContainer SiteHeightDiv">
                <div className="SiteMainHeightDiv">
                    <div className="SiteLeftContainer AutoHgtSiteScrollbar">
                        <div className='ZoneHeaderDiv'>
                            <button className="addCustomer" onClick={handleSite}>
                                <span className="ViewUpdate">
                                <img src={LeftArrowWhite} alt="add plus icon" />
                                </span>
                            </button>
                            <p>{site?.SiteName}</p>
                        </div>
                        <div className="m-2 HeaderSiteList">
                            <input
                                id="Search_txt_site"
                                className="SearchViewInput1"
                                type="text"
                                value={searchZoneName}
                                onChange={(e) => {onSearchChange(e.target.value)}}
                                placeholder="Search Zone"/>
                            <div className="SearchTextDivConfigTool">
                                {
                                isDarkTheme ?
                                    <img
                                    className="EyeIcon"
                                    src={SearchIcon}
                                    alt="search icon"
                                    /> :
                                    <img
                                    className="EyeIcon"
                                    src={SearchIconWhite}
                                    alt="search icon" height="15"
                                    />
                                }
                            </div>
                        </div>
                        <div className="StepperSiteList" id="siteListDiv" style={{height:"62vh"}}>
                            {
                                zoneList && (
                                    zoneList.length > 0
                                    ?
                                    zoneList?.map((item) => (
                                        <div key={item?.SiteID} 
                                        className={selectedZone?.SiteID == item?.SiteID ? `OneList SelectedList p-0 pr-1` : `OneList p-0 pr-1`}
                                        >
                                        <div className="ListSiteWithZone"
                                        onClick={(e) => {
                                            getSiteAddressDetails(item?.SiteID, item)
                                            setActiveTabKey("Zone_Details")
                                            // setSelectedZone(item)
                                            setIsFormEdit(true)
                                        }}
                                        >
                                            <p className="ListofText">
                                            {item?.SiteName}
                                            </p>
                                        </div>
                                    </div> 
                                    ))
                                    : 
                                    <div className="no-data-found"><p>No Zones Found</p></div>
                                )
                            }
                            {
                                !zoneList && (
                                    <div className="no-data-found">No Zones Available</div>
                                )
                            }
                        </div>
                    </div>
                    
                    <div className="SiteRightContainer">
                        <Tabs defaultActiveKey="Zone_Details" id="uncontrolled-tab-example" className="AlertTemplateTab" activeKey={activeTabKey}
                        onSelect={(e) => { setActiveTabKey(e)}}
                        >
                            <Tab eventKey="Zone_Details" title="Zone Details">
                                <ZoneDetailsForm site={site} country={country} countryState={countryState} isFormEdit={isFormEdit} setIsFormEdit={setIsFormEdit} selectedZone={selectedZone} setSelectedZone={setSelectedZone} getZoneList={getZoneList}/>
                            </Tab>
                            <Tab eventKey="Zone_Map" title="Map" disabled={(selectedZone == null)} style={{height:"100%"}}>
                                <ZoneMap site={site} isDarkTheme={isDarkTheme} selectedZone={selectedZone} getZoneList={getZoneList}/>
                            </Tab>
                            <Tab eventKey="Emergency_Details" title="Emergency Contact" disabled={(selectedZone == null)}>
                                <TabEmergencyContact selectedZone={selectedZone} isDarkTheme={isDarkTheme} />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddZoneForm